import { Route, Routes, Navigate } from 'react-router-dom'

import PrivateRoute from './PrivateRoute'
import LoggedInArea from '../components/LoggedInArea'
import Calendar from '../pages/Calendar'
import CreatePassword from '../pages/CreatePassword'
import Login from '../pages/Login'
import PublishContent from '../pages/PublishContent'
import Settings from '../pages/Settings/GerenciarPerfilUsuario'
import GerenciarPerfilUsuario from '../pages/Settings/GerenciarPerfilUsuario/gerenciar-perfil-usuario/gerenciar-perfil-usuario'
import EditarPerfilUsuario from '../pages/Settings/GerenciarPerfilUsuario/editar-perfil-usuario/editar-perfil-usuario'
import Comunicacao from '../pages/Settings/ServicoComunicacao/servico-comunicacao'
import CreateText from '../pages/PublishContent/components/WhatToPublish/createText'
import CreateVideo from '../pages/PublishContent/components/WhatToPublish/createVideo'
import ForgotPassword from '../pages/ForgotPassword'
import AfterPage from '../pages/ForgotPassword/afterPage'
import ChangePassword from '../pages/ForgotPassword/changePassword'
import Publicacao from '../pages/publicacao/Publicacao'
import Noticia from '../pages/publicacao/noticia/gerenciar-noticia'
import InserirNoticia from '../pages/publicacao/noticia/inserir-noticia/inserir-noticia'
import EditarNoticia from '../pages/publicacao/noticia/editar-noticia/editar.noticia'
import AprovarNoticia from '../pages/publicacao/noticia/aprovar-noticia/aprovar.noticia'
import GerenciarCategoria from '../pages/Settings/GerenciarCategoria/gerenciar-categoria'
import CriarCategoria from '../pages/Settings/GerenciarCategoria/adicionar-categoria/adicionar-categoria'
import EditarCategoria from '../pages/Settings/GerenciarCategoria/editar-categoria/editar-categoria'
import GerenciarAplicativo from '../pages/Settings/Aplicativo/gerenciar-aplicativo'
import NovoAplicativo from '../pages/Settings/Aplicativo/novoAplicativo/novo-aplicativo'
import EditarAplicativo from '../pages/Settings/Aplicativo/editar-aplicativo/editar-aplicativo'
import Banner from '../pages/publicacao/banner/gerenciar-banner'
import InserirBanner from '../pages/publicacao/banner/inserir-banner/inserir-banner'
import EditarBanner from '../pages/publicacao/banner/editar-banner/editar-banner'
import AprovarBanner from '../pages/publicacao/banner/aprovar-banner/aprovar-banner'
import GerenciarMenu from '../pages/Settings/gerenciar-menu/gerenciar-menu'
import ConfigurarMidia from '../pages/PublishContent/configurarMidia/configurar-midia'
import GerenciarMidiasSociais from '../pages/PublishContent/gerenciar-midias-sociais/gerenciar-midias-sociais'
import EditarMidiaSocial from '../pages/PublishContent/editar-midia-social/editar-midia-social'
import TelaInicio from '../pages/Inicio/inicio'
import VisualizacaoNecesidadeAtuacao from '../pages/Inicio/Cards/visualizacaoNecessidadeAtuacao/visualizacao-necessidade-atuacao'
import GerenciarUsuario from '../pages/Settings/gerenciar-usuario/gerenciar-usuario'
import AdicionarUsuario from '../pages/Settings/gerenciar-usuario/adicionar-usuario/adicionar-usuario'
import EditarUsuario from '../pages/Settings/gerenciar-usuario/editar-usuario/editar-usuario'
import EdicaoCms from '../pages/EdicaoCidadeInteligente/edicao-cms'
import GerenciarPublicacaoRedesSociais from '../pages/publicacao/rede-social/gerenciar-rede-social'
import EditarPublicacaoRedeSocial from '../pages/publicacao/rede-social/editar-rede-social/editar-rede-social'
import Cabecalho from '../pages/EdicaoCidadeInteligente/cabecalho/editar-cabecalho'
import FaixaNavegacaoPrincipal from '../pages/EdicaoCidadeInteligente/FaixaNavegacaoPrincipal/faixa-navegacao'
import InserirRedeSocial from '../pages/publicacao/rede-social/inserir-rede-social/inserir-rede-social'
import AprovarPublicacaoRedeSocial from '../pages/publicacao/rede-social/aprovar-rede-social/aprovar-rede-social'
import GerenciarEvento from '../pages/publicacao/eventos/gerenciar-evento'
import InserirEvento from '../pages/publicacao/eventos/inserir-evento/inserir-evento'
import EditarEvento from '../pages/publicacao/eventos/editar-evento/editar-evento'
import AprovarEvento from '../pages/publicacao/eventos/aprovar-evento/aprovar-evento'
import GerenciarPaginas from '../pages/EdicaoCidadeInteligente/OutrasPaginas/gerenciar-paginas'
import InserirPagina from '../pages/EdicaoCidadeInteligente/OutrasPaginas/inserir-pagina/inserir-pagina'
import InserirModelo1 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-1/InserirModelo1/inserir-modelo-1'
import EditarModelo1 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-1/EditarModelo1/editar-modelo-1'
import EditarPagina from '../pages/EdicaoCidadeInteligente/OutrasPaginas/editarPagina/editar-pagina'
import Rodape from '../pages/EdicaoCidadeInteligente/Rodape/rodape'
import GerenciarBibliotecaMidiaDigital from '../pages/publicacao/bibliotecaMidiaDigital/gerenciar-biblioteca-midia-digital'
import InserirMidiaDigital from '../pages/publicacao/bibliotecaMidiaDigital/inserirMidiaDigital/inserir-midia-digital'
import EditarMidiaDigital from '../pages/publicacao/bibliotecaMidiaDigital/editarMidiaDigital/editar-midia-digital'
import GerenciarTipoMidia from '../pages/Settings/GerenciarTipoMidia/gerenciar-tipo-midia';
import InserirTipoMidia from '../pages/Settings/GerenciarTipoMidia/inserir-tipo-midia/inserir-tipo-midia';
import EditarTipoMidia from '../pages/Settings/GerenciarTipoMidia/editar-tipo-midia/editar-tipo-midia';
import InserirModelo3 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-3/InserirModelo3/inserir-modelo-3';
import EditarModelo3 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-3/EditarModelo3/editar-modelo-3'
import InserirModelo4 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-4/InserirModelo4/inserir-modelo-4'
import EditarModelo4 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-4/EditarModelo4/editar-modelo-4'
import InserirModelo5 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-5/InserirModelo5/inserir-modelo-5'
import EditarModelo5 from '../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/modelo-5/EditarModelo5/editar-modelo-5'
import AvisoPublicacoesRejeitadas from '../pages/Inicio/Cards/publicacoes-rejeitadas/aviso-publicacoes-rejeitadas'
import PaginaNaoEncontrada from '../pages/paginaNaoEncontrada/index';
import Relatorios from '../pages/relatorios/Relatorios';
import RelatorioRedeSocial from '../pages/relatorios/GridRelatorios/RelatorioRedeSocial/RelatorioRedeSocial'
import ListaIconesPublicacaoRedeSocial from '../pages/publicacao/rede-social/lista-icones-publicacao-rede-social/lista-icones-publicacao-rede-social';
import GerenciarSecretarias from '../pages/Settings/gerenciar-secretarias/gerenciar-secretaria';
import EditarSecretaria from '../pages/Settings/gerenciar-secretarias/editar-secretaria/editar-secretaria';
import AdicionarSecretaria from '../pages/Settings/gerenciar-secretarias/adicionar-secretaria/adicionar-secretaria';
import ImprensaOficial from '../pages/publicacao/imprensa-oficial/gerenciar-imprensa-oficial';
import InserirImprensaOficial from '../pages/publicacao/imprensa-oficial/inserir-imprensa-oficial/inserir-imprensa-oficial';
import EditarImprensaOficial from '../pages/publicacao/imprensa-oficial/editar-imprensa-oficial/editar-imprensa-oficial';
import AprovarImprensaOficial from '../pages/publicacao/imprensa-oficial/aprovar-imprensa-oficial/aprovar-imprensa-oficial';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route index element={<Login />} path="/login" />
      <Route element={<CreatePassword />} path="/create-password" />
      <Route element={<ForgotPassword />} path="/forgot-password" />
      <Route element={<AfterPage />} path="/new-password" />
      <Route element={<ChangePassword />} path="/change-password/:token" />

      <Route
        path="/cms"
        element={
          <PrivateRoute>
            <LoggedInArea />
          </PrivateRoute>
        }
      >
        <Route element={<TelaInicio />} path="/cms/inicio" />
        <Route element={<Calendar />} path="calendario" />
        <Route element={<VisualizacaoNecesidadeAtuacao />} path="inicio/visualizacao-necessidade-atuacao" />
        <Route element={<AvisoPublicacoesRejeitadas />} path="inicio/aviso-publicacoes-rejeitadas" />

        <Route index element={<PublishContent />} path="configuracao/midias-sociais" />
        <Route element={<CreateText />} path="content/createText" />
        <Route element={<CreateVideo />} path="content/createVideo" />
        <Route element={<ConfigurarMidia />} path="configuracao/midias-sociais/configurar-rede-social" />
        <Route element={<GerenciarMidiasSociais />} path="configuracao/midias-sociais/gerenciar-rede-social" />
        <Route element={<EditarMidiaSocial />} path="configuracao/midias-sociais/gerenciar-rede-social/editar-rede-social/:id" />
        
        <Route element={<Settings />} path="configuracao" />

        <Route element={<Publicacao />} path="publicacao" />
        <Route element={<Noticia />} path="publicacao/noticia" />
        <Route element={<InserirNoticia />} path="publicacao/noticia/inserir-noticia" />
        <Route element={<EditarNoticia />} path="publicacao/noticia/editar-noticia/:id" />
        <Route element={<AprovarNoticia />} path="inicio/visualizacao-necessidade-atuacao/aprovar-noticia/:id" />

        <Route element={<ImprensaOficial />} path="publicacao/imprensa-oficial" />
        <Route element={<InserirImprensaOficial />} path="publicacao/imprensa-oficial/inserir-imprensa-oficial" />
        <Route element={<EditarImprensaOficial />} path="publicacao/imprensa-oficial/editar-imprensa-oficial/:id" />
        <Route element={<AprovarImprensaOficial />} path="inicio/visualizacao-necessidade-atuacao/aprovar-imprensa-oficial/:id" />

        <Route element={<GerenciarEvento />} path="publicacao/evento" />
        <Route element={<InserirEvento />} path="publicacao/evento/criar-evento" />
        <Route element={<EditarEvento />} path="publicacao/evento/editar-evento/:id" />
        <Route element={<AprovarEvento />} path="inicio/visualizacao-necessidade-atuacao/aprovar-evento/:id" />

        <Route element={<ImprensaOficial />} path="publicacao/imprensa-oficial" />

        <Route element={<Comunicacao />} path="configuracao/servico-comunicacao" />

        <Route element={<GerenciarCategoria />} path="configuracao/gerenciar-categoria" />
        <Route element={<CriarCategoria />} path="configuracao/gerenciar-categoria/criar-categoria" />
        <Route element={<EditarCategoria />} path="configuracao/gerenciar-categoria/editar-categoria/:id" />

        <Route element={<GerenciarAplicativo />} path="configuracao/aplicativo" />
        <Route element={<NovoAplicativo />} path="configuracao/aplicativo/novo-aplicativo" />
        <Route element={<EditarAplicativo />} path="configuracao/aplicativo/editar-aplicativo/:id" />

        <Route element={<GerenciarTipoMidia />} path="configuracao/gerenciar-tipo-midia" />
        <Route element={<InserirTipoMidia />} path="configuracao/gerenciar-tipo-midia/inserir-tipo-midia" />
        <Route element={<EditarTipoMidia />} path="configuracao/gerenciar-tipo-midia/editar-tipo-midia/:id" />

        <Route element={<GerenciarPerfilUsuario />} path="configuracao/gerenciar-perfil-usuario" />
        <Route element={<EditarPerfilUsuario />} path="configuracao/gerenciar-perfil-usuario/editar-perfil-usuario/:id" />

        <Route element={<GerenciarUsuario />} path="configuracao/gerenciar-usuario" />
        <Route element={<AdicionarUsuario />} path="configuracao/gerenciar-usuario/adicionar-usuario" />
        <Route element={<EditarUsuario />} path="configuracao/gerenciar-usuario/editar-usuario/:id" />

        <Route element={<GerenciarSecretarias />} path="configuracao/gerenciar-secretarias" />
        <Route element={<AdicionarSecretaria />} path="configuracao/gerenciar-secretarias/adicionar-secretaria" />
        <Route element={<EditarSecretaria />} path="configuracao/gerenciar-secretarias/editar-secretaria/:id" />
        
        <Route element={<GerenciarBibliotecaMidiaDigital />} path="publicacao/gerenciar-biblioteca" />
        <Route element={<InserirMidiaDigital />} path="publicacao/gerenciar-biblioteca/inserir-midia" />
        <Route element={<EditarMidiaDigital />} path="publicacao/gerenciar-biblioteca/editar-midia/:id" />

        <Route element={<Banner />} path="publicacao/banner" />
        <Route element={<InserirBanner />} path="publicacao/banner/novo-banner" />
        <Route element={<EditarBanner />} path="publicacao/banner/editar-banner/:id" />
        <Route element={<AprovarBanner />} path="inicio/visualizacao-necessidade-atuacao/aprovar-banner/:id" />

        <Route element={<ListaIconesPublicacaoRedeSocial />} path="publicacao/redes-sociais" />
        <Route element={<EditarPublicacaoRedeSocial />} path="publicacao/redes-sociais/publicacoes/:codRede/editar-rede-social/:id" />
        <Route element={<GerenciarPublicacaoRedesSociais />} path="publicacao/redes-sociais/publicacoes/:codRede" />
        <Route element={<InserirRedeSocial />} path="publicacao/redes-sociais/publicacoes/:codRede/incluir-rede-social" />

        <Route element={<AprovarPublicacaoRedeSocial />} path="inicio/visualizacao-necessidade-atuacao/aprovar-publicacao-rede-social/:id" />

        <Route element={<GerenciarMenu />} path="configuracao/gerenciar-menu" />

        <Route element={<EdicaoCms />} path="edicao-cidade-inteligente" />
        <Route element={<Cabecalho />} path="edicao-cidade-inteligente/editar-cabecalho" />
        <Route element={<FaixaNavegacaoPrincipal />} path="edicao-cidade-inteligente/faixa-navegacao-principal" />
        <Route element={<Rodape />} path="edicao-cidade-inteligente/rodape" />
        <Route element={<GerenciarPaginas />} path="edicao-cidade-inteligente/outras-paginas" />
        <Route element={<InserirPagina />} path="edicao-cidade-inteligente/outras-paginas/inserir-pagina" />
        <Route element={<InserirModelo1 />} path="edicao-cidade-inteligente/outras-paginas/inserir-pagina/modelo-1" />
        <Route element={<EditarModelo1 />} path="edicao-cidade-inteligente/outras-paginas/editar-pagina-modelo-1/:id" />
        <Route element={<InserirModelo3 />} path="edicao-cidade-inteligente/outras-paginas/inserir-pagina/modelo-3" />
        <Route element={<EditarModelo3 />} path="edicao-cidade-inteligente/outras-paginas/editar-pagina-modelo-3/:id" />
        <Route element={<InserirModelo4 />} path="edicao-cidade-inteligente/outras-paginas/inserir-pagina/modelo-4" />
        <Route element={<EditarModelo4 />} path="edicao-cidade-inteligente/outras-paginas/editar-pagina-modelo-4/:id" />
        <Route element={<InserirModelo5 />} path="edicao-cidade-inteligente/outras-paginas/inserir-pagina/modelo-5" />
        <Route element={<EditarModelo5 />} path="edicao-cidade-inteligente/outras-paginas/editar-pagina-modelo-5/:id" />
        <Route element={<EditarPagina />} path="edicao-cidade-inteligente/outras-paginas/editar-pagina/:id" />

        <Route element={<Relatorios />} path="relatorios" />
        <Route element={<RelatorioRedeSocial />} path="relatorios/relatorio-rede-social" />

      </Route>
      <Route path="*" element={<PaginaNaoEncontrada />} />
    </Routes>
  )
}

export default AppRoutes
